/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
/**
 * Describes what to do with ignored files..
 */
export const IgnoreHandling = /* #__PURE__ */ parsers.exactly('keep', 'delete', 'error');
